exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n  margin-bottom: 5px; }\n\n.card-block {\n  padding: 5px;\n  font-size: 13px; }\n\nstrong {\n  font-size: 12px; }\n\n.profile {\n  border-radius: 5px;\n  width: 45px; }\n\n.col-sm-1 {\n  margin-top: 11px; }\n\n.btn, .fc button {\n  margin-top: 10px;\n  background: white; }\n\n.color {\n  color: #93bf35; }\n\n.fa-toggle-on:before {\n  content: \"\\F205\";\n  margin-left: -20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/users-list/user-list.component.scss
// module id = 512
// module chunks = 5